import { render } from "./userconsole.vue?vue&type=template&id=04b7245f&scoped=true"
import script from "./userconsole.vue?vue&type=script&lang=js"
export * from "./userconsole.vue?vue&type=script&lang=js"

import "./userconsole.vue?vue&type=style&index=0&id=04b7245f&lang=scss&scoped=true"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b7245f"]])

export default __exports__